import useSWR from 'swr'
import API from '../../../utils/api'
import { getPersistData } from '../../hooks/persist'
import { useToken } from 'app/hooks'

const KEY = '/users?page=1&maxData=1000' // (8)지점 조회

let swrData = null;
export function useUserList(usertype:any) {
	let REALKEY = KEY + '&usertype=' + usertype

	if(swrData == null) {
		swrData = getPersistData(REALKEY)
	}

	const { data: token } = useToken()
	const { data, mutate } = useSWR<any>(
		REALKEY,
		async () => {
			const response = await API.get(REALKEY, token + '', {})
			swrData = response.result?.result?.list

			return swrData
		},
		{ revalidateOnFocus: true }
	)

	return {
		data: data,
		mutate: (value?: any) => {
			if (value != undefined) {
				swrData = value
			}
			return mutate()
		},
	}
}
